import React from 'react';

type IconProps = React.SVGAttributes<SVGElement> & {
	size: number;
};

const ArrowBigLeft = ({ size, ...props }: IconProps): React.ReactElement => (
	<svg
		width={size}
		height={size}
		viewBox="0 0 32 32"
		xmlns="http://www.w3.org/2000/svg"
		{...props}
	>
		<path d="M16 4C18.206 4 20 5.794 20 8C20 9.042 19.601 10.029 18.877 10.779C18.871 10.786 18.864 10.792 18.858 10.798L17.632 12H23.999C26.205 12 27.999 13.794 27.999 16C27.999 18.206 26.205 20 23.999 20H17.634L18.821 21.165C19.572 21.916 19.999 22.947 19.999 24C19.999 26.206 18.205 28 15.999 28C14.946 28 13.915 27.573 13.17 26.828L5.16999 18.828C4.42499 18.083 3.99899 17.052 3.99899 15.999C3.99899 14.946 4.42599 13.915 5.16999 13.171L13.17 5.171C13.915 4.426 14.945 4 15.999 4H16ZM17.447 9.38C17.804 9.006 18 8.517 18 8C18 6.897 17.103 6 16 6C15.473 6 14.958 6.213 14.586 6.586L6.58599 14.586C6.21399 14.958 5.99999 15.474 5.99999 16C5.99999 16.526 6.21299 17.042 6.58599 17.414L14.586 25.414C14.958 25.786 15.474 26 16 26C17.103 26 18 25.103 18 24C18 23.474 17.787 22.958 17.414 22.586L14.487 19.714C14.197 19.43 14.108 18.998 14.262 18.622C14.416 18.246 14.782 18 15.188 18H24C25.103 18 26 17.103 26 16C26 14.897 25.103 14 24 14H15.185C14.779 14 14.413 13.754 14.259 13.378C14.105 13.002 14.194 12.57 14.484 12.286L17.446 9.38H17.447Z" />
	</svg>
);

export default ArrowBigLeft;
